import * as React from 'react';
import * as classnames from 'classnames';
import {TreeNode} from './pathUtils';
import {Icon} from '../../util';
import {getAdjustedFontStyle} from '../_util';

export interface TreeViewExpandedState {
	[path: string]: boolean;
}

export interface TreeViewErrorState {
	[path: string]: string;
}

interface TreeViewProps {
	className?: string;
	editingPath: string;
	fontSizeAdjustment: number;
	node: TreeNode;
	expandedState: TreeViewExpandedState;
	errorState: TreeViewErrorState;
	onClickDirectory(path: string): void;
	onClickFile(path: string): void;
	getFileIcon?(path: string): string;
}

const DEFAULT_DIRECTORY_FONT_SIZE: number = 16;
const DEFAULT_FILE_FONT_SIZE: number = 14.4;

export default class TreeView extends React.Component<TreeViewProps, {}> {

	public render() {
		const className = classnames('tree-view', this.props.className || '');
		return <ul className={className}>
			{this.renderDirectories()}
			{this.renderFiles()}
		</ul>;
	}

	private renderDirectories(): JSX.Element[] {
		const children = this.props.node.children;
		return Object.keys(children)
			.filter(name => children[name].type === 'DIRECTORY')
			.sort()
			.map(name => {
				const node = children[name];
				const path = node.path;
				const expanded = this.props.expandedState[path];
				return <li
					key={name}
					className='tree-view__directory'
					style={getAdjustedFontStyle(DEFAULT_DIRECTORY_FONT_SIZE, this.props.fontSizeAdjustment)}
				>
					<a onClick={this.props.onClickDirectory.bind(null, path)}>
						<Icon name={expanded ? 'folder-open-o' : 'folder-o'} fixedWidth /> {name}
						{this.renderDirectoryErrorIcon(path)}
					</a>
					{expanded && this.renderDirectoryChildren(node)}
				</li>;
			});
	}

	private renderDirectoryChildren(node: TreeNode) {
		return <TreeView
			node={node}
			editingPath={this.props.editingPath}
			fontSizeAdjustment={this.props.fontSizeAdjustment}
			expandedState={this.props.expandedState}
			errorState={this.props.errorState}
			onClickDirectory={this.props.onClickDirectory}
			onClickFile={this.props.onClickFile}
			getFileIcon={this.props.getFileIcon}
		/>;
	}

	private renderFiles() {
		const children = this.props.node.children;
		return Object.keys(children)
			.filter(name => children[name].type === 'FILE')
			.sort()
			.map(name => {
				const path = children[name].path;
				return <li
					key={name}
					className='tree-view__file'
					style={getAdjustedFontStyle(DEFAULT_FILE_FONT_SIZE, this.props.fontSizeAdjustment)}
				>
					<a className={this.getFileLinkClass(path)} onClick={this.props.onClickFile.bind(null, path)}>
						<Icon name={this.getFileIcon(path)} fixedWidth /> {name}
						{this.renderFileErrorIcon(path)}
					</a>
				</li>;
			});
	}

	private getFileIcon(path: string) {
		if (this.props.getFileIcon) {
			return this.props.getFileIcon(path);
		} else {
			return 'file-o';
		}
	}

	private renderDirectoryErrorIcon(path: string) {
		const errorState = this.getErrorState();
		const containsError = Object.keys(errorState).some(errorPath =>
			errorState[errorPath] && errorPath.indexOf(path + '/') === 0,
		);
		return containsError ? this.renderErrorIcon() : null;
	}

	private renderFileErrorIcon(path: string) {
		return this.getErrorState()[path] ? this.renderErrorIcon() : null;
	}

	private getErrorState() {
		return this.props.errorState || {};
	}

	private renderErrorIcon() {
		return <Icon name='warning' className='error-icon' fixedWidth />;
	}

	private getFileLinkClass(path: string) {
		return this.props.editingPath === path ? 'active-file' : '';
	}

}



// WEBPACK FOOTER //
// ./node_modules/tslint-loader!./ts/components/config-editor/treeview/TreeView.tsx